import React, { useEffect, useState } from 'react';
import FilterSelect from '@/components/atoms/FilterSelect/FilterSelect';
import { Scope } from '@/types/types';
import { useTranslations } from 'next-intl';

interface ScopeFilterProps {
  onFilterChange: (filter: { scope: Scope | "" }) => void;
  scope: Scope | "";
  disabled?: boolean;
}

const ScopeFilter: React.FC<ScopeFilterProps> = ({ onFilterChange, scope, disabled }) => {
  const [selectedScope, setSelectedScope] = useState<Scope | "">(scope);

  const f = useTranslations('filter');

  const scopeOptions = [
    {value: '', label: f('all') },
    { value: 'team', label: f('team') },
    { value: 'opponent', label: f('opponents') },
    { value: 'combined', label: f('combined') }
  ];

  useEffect(() => {
    setSelectedScope(scope);
  }, [scope]);

  const handleChange = (value: number | string) => {
    onFilterChange({ scope: value as Scope});
    setSelectedScope(value as Scope);
  };

  return (
    <FilterSelect
      label={f("scope")}
      options={scopeOptions}
      onChange={handleChange}
      value={selectedScope}
      disabled={disabled}
    />
  );
};

export default ScopeFilter;
